import styled from '@emotion/styled'
import React, { useState } from 'react'
import splashBackground from '../../assets/icons/background-splash-home.svg'
import IconAgendamento from '../../assets/icons/icon-agendamento.svg'
import IconConsultarAgendamento from '../../assets/icons/icon-consultar-agendamento.svg'
import { Button } from '../../components/inputs/Button'
import { useHistory } from 'react-router-dom'
import newIconLogo from '../../assets/icons/new-logo-icon.png'

export default function Home() {
  const { Layout, ContainerButtons, Button, Container } = Home
  const history = useHistory()
  return (
    <Layout>
      <Container>
        <div className="logo-home">
          <img src={newIconLogo} />
        </div>
        <ContainerButtons>
          <Button onClick={() => history.push('/agendamentos/agendar')}>
            <div className="content-button-home">
              <img src={IconAgendamento} />
              Agendamento
            </div>
          </Button>

          <Button onClick={() => history.push('/agendamentos/consultar')}>
            <div className="content-button-home">
              <img src={IconConsultarAgendamento} />
              Consultar Agendamento
            </div>
          </Button>
        </ContainerButtons>
      </Container>
    </Layout>
  )
}

Home.Layout = styled.div`
  min-height: 100vh;
  display: grid;
  place-items: center;
  background: #f7d047;
  justify-content: center;
`

Home.Container = styled.div`
  display: grid;
  gap: 100px;
  .logo-home {
    display: flex;
    justify-content: center;
    img {
      width: 220px;
    }
  }
`

Home.ContainerButtons = styled.div`
  display: grid;
  gap: 20px;
`

Home.Button = styled(Button)`
  min-width: 300px;
  padding: 9px 0px;
  font-size: 20px;
  .content-button-home {
    display: flex;
    gap: 8px;
    justify-content: center;
  }
`
